<button
    class="button -blue -negative hide sm:show"
    type="button"
    [ngClass]="{ '-negative': styleRejectNegative() }"
    (click)="clickReject.emit()"
>
    @if (rejectIcon()) {
        <i [ctrlIcon]="rejectIcon()"></i>
    }
    {{ rejectText() }}
</button>

<button
    class="button -blue"
    [ngClass]="{ '-negative': styleConfirmNegative() }"
    [type]="isUsedToSubmitForm() ? 'submit' : 'button'"
    (click)="clickConfirm.emit()"
    [disabled]="isConfirmDisabled()"
>
    @if (confirmIcon()) {
        <i [ctrlIcon]="confirmIcon()"></i>
    }
    {{ confirmText() }}
</button>

<button
    class="button -blue -negative sm:hide"
    type="button"
    [ngClass]="{ '-negative': styleRejectNegative() }"
    (click)="clickReject.emit()"
>
    @if (rejectIcon()) {
        <i [ctrlIcon]="rejectIcon()"></i>
    }
    {{ rejectText() }}
</button>
